import React from 'react'
import IndexStarpath from "../../components/index/IndexStarpath";

const HomeSix = () => {
  return (
     <IndexStarpath/>
  )
}

export default HomeSix